import { render } from "./ManagerForm.vue?vue&type=template&id=0ecc1930"
import script from "./ManagerForm.vue?vue&type=script&lang=js"
export * from "./ManagerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__